<template>
    <app-primary>
        <template #contentsHead>
            <sub-head-primary itemTitle="단지안내" tabActive="단위세대 평면안내" bg="/images/sub/complex/visual.jpg">
                <template #title>단지안내</template>
            </sub-head-primary>
        </template>

        <page-section-primary titWrapClass="text-center" class="page-section--first page-section--last position-relative">
            <template #tit>단위세대 평면안내</template>

            <!-- S: 3D 모델링보기 -->
            <div class="link-3d">
                <v-row no-gutters justify="end">
                    <v-col cols="12" md="4" lg="2">
                        <v-row class="row--xxs">
                            <v-col cols="12">
                                <v-btn block color="primary" outlined class="rounded-pill" href="https://my.matterport.com/show/?m=CyoWyQmtW6W" target="_blank">
                                    <span class="font-weight-bold">25 TYPE 3D 모델링보기</span>
                                </v-btn>
                            </v-col>
                            <v-col cols="12">
                                <v-btn block color="primary" outlined class="rounded-pill" href="https://my.matterport.com/show/?m=bX9uPnLQD2X" target="_blank">
                                    <span class="font-weight-bold">52 TYPE 3D 모델링보기</span>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </div>
            <!-- E: 3D 모델링보기 -->

            <!-- S: 탭 -->
            <div class="page-section__content">
                <div class="unit-tabs">
                    <v-tabs grow hide-slider centered v-model="tab" class="v-tabs--density-compact">
                        <template v-for="(item, index) in items">
                            <tab-quarternary :key="index" class="text-uppercase">
                                {{ item.area }}
                                {{ item.type }} TYPE
                            </tab-quarternary>
                        </template>
                    </v-tabs>
                </div>
            </div>
            <!-- E: 탭 -->

            <div class="page-section__content">
                <v-tabs-items v-model="tab">
                    <template v-for="(item, index) in items">
                        <v-tab-item :key="index" eager>
                            <!-- S: 표 -->
                            <div class="page-section__content">
                                <div class="v-data-table v-data-table--border v-data-table--line v-data-table--density-comfortable">
                                    <div class="v-data-table__wrapper">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <template v-for="(item, index) in thead">
                                                        <th-primary :key="index">
                                                            {{ item }}
                                                        </th-primary>
                                                    </template>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <th-secondary>
                                                        <span class="text-uppercase">{{ item.type }}</span> TYPE
                                                    </th-secondary>
                                                    <template v-for="(area, index) in item.areas">
                                                        <td-primary :key="index">{{ area }}㎡</td-primary>
                                                    </template>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <!-- E: 표 -->

                            <!-- S: 이미지 -->
                            <div class="page-section__content">
                                <sheet-secondary class="py-md-40px" align="center">
                                    <img :src="`/images/sub/complex/unit/${item.type}-type.jpg`" alt="" />
                                </sheet-secondary>
                            </div>
                            <!-- E: 이미지 -->
                        </v-tab-item>
                    </template>
                </v-tabs-items>
            </div>
        </page-section-primary>
    </app-primary>
</template>

<script>
import AppPrimary from "@/sets/parents/apps/app-primary.vue";
import SubHeadPrimary from "@/sets/parents/pages/sub-head-primary.vue";
import PageSectionPrimary from "@/sets/parents/pages/page-section-primary.vue";
import UBtnFlatPill from "@/components/publish/styles/buttons/u-btn-flat-pill.vue";
import UTxtDefault from "@/components/publish/styles/typography/u-txt-default.vue";
import SheetSecondary from "@/components/publish/parents/sheets/sheet-secondary.vue";
import ThPrimary from "@/components/publish/parents/tables/th-primary.vue";
import ThSecondary from "@/components/publish/parents/tables/th-secondary.vue";
import TdPrimary from "@/components/publish/parents/tables/td-primary.vue";
import TabQuarternary from "@/components/publish/parents/tabs/tab-quarternary.vue";

export default {
    props: {},
    components: {
        AppPrimary,
        SubHeadPrimary,
        PageSectionPrimary,
        UBtnFlatPill,
        UTxtDefault,
        SheetSecondary,
        ThPrimary,
        ThSecondary,
        TdPrimary,
        TabQuarternary,
    },
    data: () => ({
        tab: null,
        items: [
            {
                type: "25a",
                areas: [
                    // 전용면적
                    "20.17",
                    // 공용면적
                    "13.60",
                    // 공급면적
                    "33.77",
                    // 주차장 외 공용
                    "13.13",
                    // 계약면적
                    "46.90",
                ],
            },
            {
                type: "25b",
                areas: [
                    // 전용면적
                    "20.40",
                    // 공용면적
                    "13.76",
                    // 공급면적
                    "34.16",
                    // 주차장 외 공용
                    "13.29",
                    // 계약면적
                    "47.45",
                ],
            },
            {
                type: "52a",
                areas: [
                    // 전용면적
                    "41.25",
                    // 공용면적
                    "27.82",
                    // 공급면적
                    "69.07",
                    // 주차장 외 공용
                    "26.86",
                    // 계약면적
                    "95.93",
                ],
            },
            {
                type: "52b",
                areas: [
                    // 전용면적
                    "42.17",
                    // 공용면적
                    "28.44",
                    // 공급면적
                    "70.61",
                    // 주차장 외 공용
                    "27.46",
                    // 계약면적
                    "98.07",
                ],
            },
        ],
        thead: [
            "TYPE",
            "전용면적",
            "공용면적",
            "공급면적",
            "주차장 등 공용면적",
            "계약면적",
            //
        ],
    }),
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.unit-tabs {
    ::v-deep {
        .v-tab--button {
            --tab-margin-compact: 6px !important;
        }
        .v-tabs-bar__content {
            flex-wrap: wrap;
            max-width: 100%;
        }
        .v-tabs--grow > .v-tabs-bar .v-tab {
            flex: 0 0 calc(50% - 12px) !important;
        }
    }
}
@media (min-width: 768px) {
    .unit-tabs {
        ::v-deep {
            .v-tabs--grow > .v-tabs-bar .v-tab {
                flex: 0 0 calc(25% - 12px) !important;
            }
        }
    }
}
.link-3d {
    margin: 18px 0;
}
@media (min-width: 1024px) {
    .link-3d {
        margin: 0;
        width: 100%;
        position: absolute;
        top: 0;
        right: var(--container-gutter);
    }
}
</style>
